module.exports = __webpack_public_path__ + "img/arrow-left.ed4039f9.svg";